module.exports = __webpack_public_path__ + "media/integrations/woo-610c1762.svg";